module.exports = __webpack_public_path__ + "img/social-icon-twitter.56840bf8.svg";